































import Vue from 'vue';
import Box from './components/Box.vue';
import FileUpload from './components/FileUpload.vue';
import ResultsTable from './components/ResultsTable.vue';
export default Vue.extend({
  name: 'Landing',
  data() {
    return {
      requiredFileNames: ['project.json', 'respondents.csv'] as Array<string>,
      resultsReceived: false as boolean,
      displayTitle: '' as string,
      displaySubtitle: '' as string,
      tableData: [] as Array<object>,
    };
  },
  beforeMount() {
    this.displayTitle = this.title;
    this.displaySubtitle = this.subTitle;
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    subTitle: {
      type: String,
      required: true,
    },
  },
  components: {
    'file-upload': FileUpload,
    'results-table': ResultsTable,
    Box,
  },
  methods: {
    handleResults($event: object): void {
      this.displayTitle = 'Your results are ready.';
      this.displaySubtitle = 'Thank you for using Matcher';
      // @ts-ignore
      this.tableData = $event;
      this.resultsReceived = true;
    },
    reset() {
      this.displayTitle = this.title;
      this.displaySubtitle = this.subTitle;
      this.tableData = [];
      this.resultsReceived = false;
    },
  },
});
